// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.assortmentPlanning', {
        url: '/assortmentplanning',
        templateUrl: 'main/order/assortmentplanning/assortmentplanning.tpl.html',
        controller: 'AssortmentPlanningController as vm'
    });
}

// @ngInject
function AssortmentPlanningController($state, $window, $scope, OrdersApiService, loadSpinnerService, ResourcesService) {
    var vm = this;

    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = 15;
    vm.totalItems = 0;

    vm.purchaseOrders = [];

    vm.transitionToState = transitionToState;

    vm.onlyOrderChangeOrders = true;
    vm.onlyUndelivered = false;

    activate();

    function activate() {
        console.log("Activating");
        OrdersApiService.getPurchaseOrders(vm.currentPage, vm.searchTerm, vm.itemsPerPage, vm.onlyUndelivered, vm.onlyOrderChangeOrders).then(function(response) {
            vm.purchaseOrders = response.data.data;
        }, function(error) {
            console.log(error);
        });
    }

    function transitionToState(purchaseOrderId) {
        console.log("State.go");
        $state.go('order.purchaseorder', {purchaseOrderId: purchaseOrderId});
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

}

angular
    .module('order.assortmentplanning', [])
    .config(stateConfig)
    .controller('AssortmentPlanningController', AssortmentPlanningController);
